<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Inventario en Tr&aacute;nsito</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <div class="row align-items-end">
        <div class="col-lg-4 col-md-6 mb-3">
          <label>Regi&oacute;n</label>
          <aph-custom-select
            [items]="regionList"
            bindLabel="RegionName"
            bindValue="UnitId"
            type="default"
            placeholder="-- Seleccione Región --"
            [selectedValue]="unit"
            (returnValue)="unit = $event; applyFilters($event)">
          </aph-custom-select>
        </div>

        <div class="col-lg-4 col-md-6 mb-3">
          <label>Clasificaci&oacute;n</label>
          <aph-custom-select
            [items]="[{'id': 0, 'Name': 'PLANTA'}, {'id': 1, 'Name': 'CEVE'}]"
            bindLabel="Name"
            bindValue="id"
            type="default"
            placeholder="-- Seleccione Clasificación --"
            [selectedValue]="type"
            (returnValue)="type = $event; cmbUnitChange($event)">
          </aph-custom-select>
        </div>

        <div class="col-lg-4 col-md-12 mb-3">
          <label>Nodo:</label>
          <aph-custom-select
            [items]="nodeList"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Todos los nodos --"
            [selectedValue]="selectedOriginUnit"
            (returnValue)="onOriginUnitChange($event)">
          </aph-custom-select>
        </div>
      </div>

      <hr class="my-4">

      <div class="row">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" 
            [label]="downloading ? 'Generando...' : 'Descargar reporte'" 
            [loading]="downloading"
            [disabled]="downloading"
            (btnClick)="download()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>